export default __webpack_public_path__ + "94ea9b12af9d773713a241cf6e4cb10b.svg";